import React from "react";

export interface TabProps<T> {
  tabKey: T;
  renderTitle: (isActive: boolean) => React.ReactNode;
  children: React.ReactNode;
}
export const Tab = <T extends string>(props: TabProps<T>) => {
  const { children } = props;
  return <>{children}</>;
};
